import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import "typeface-lato";

function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}

ReactDOM.render(<WrappedApp />, document.getElementById("root"));
